import React from "react";
import { User } from "./types";
import './FriviligePage.css';

interface Props {
    volunteers: User[];
    onLoginAs?: (user: User) => void; // ✅ Add optional impersonation prop
}

const FriviligeList: React.FC<Props> = ({ volunteers, onLoginAs }) => (
    <div className="nice-table-wrap">
        <table
            className="event-table event-table-modern nice-table"
        >
            <thead>
                <tr>
                    <th>Email</th>
                    <th>Fornavn</th>
                    <th>Efternavn</th>
                    <th>Telefon</th>
                    <th>Handling</th> {/* Add column for impersonate */}
                </tr>
            </thead>
            <tbody>
                {volunteers.map(v => (
                    <tr key={v.userId}>
                        <td>{v.email}</td>
                        <td>{v.firstName}</td>
                        <td>{v.lastName}</td>
                        <td>{v.phone}</td>
                        <td>
                            {onLoginAs && (
                                <button className="btn btn--function" onClick={() => onLoginAs(v)}>
                                    Login som
                                </button>
                            )}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default FriviligeList;